import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import { useCollectionStateContext } from 'Context/CollectionStateContext';
import NullComponent from 'Components/UI/NullComponent';
import { AuthFactorModalContent } from './Content';

const AuthenticationFactorListContainer = () => {
  const { isInitializing, loadingError } = useCollectionStateContext();

  return (
    <DataContainer
      component={AuthFactorModalContent}
      loading={isInitializing}
      skeleton={NullComponent}
      loadingError={loadingError}
    />
  );
};

AuthenticationFactorListContainer.propTypes = {
};

export default AuthenticationFactorListContainer;
